// 日本語翻訳
export const ja = {
  title: 'HandinCap',
  subtitle: 'あなたのスコアカード',
  create: '新しいゲームを作成',
  courseTitle: 'コース設定',
  autoMode: '自動検索',
  manualMode: '手動入力',
  searchPlaceholder: 'コース名を検索...',
  selectCourse: 'コースを選択',
  gameType: 'ゲームタイプ',
  setPar: 'PAR値を設定',
  confirmCourse: '確認',
  playerTitle: 'プレーヤー設定',
  players: 'プレーヤー',
  player1: 'プレーヤー1',
  player2: 'プレーヤー2',
  player3: 'プレーヤー3',
  player4: 'プレーヤー4',
  player5: 'プレーヤー5',
  player6: 'プレーヤー6',
  player7: 'プレーヤー7',
  player8: 'プレーヤー8',
  enterName: '名前を入力',
  gameMode: 'ゲームモード',
  matchPlay: 'マッチプレー',
  win123: 'Win123',
  skins: 'スキンズ',
  baccarat: 'バカラ',
  stake: '賭け金',
  prizePool: '賞金プール',
  penaltyPot: 'ペナルティポット',
  optional: '任意',
  enterStake: '金額を入力（任意）',
  handicap: 'ハンディキャップ',
  handicapSettings: 'ハンディキャップ設定',
  off: 'オフ',
  on: 'オン',
  back: '戻る',
  start: 'ゲーム開始',
  hole: 'ホール',
  par: 'PAR',
  nextHole: '確認して次へ',
  currentMoney: 'ライブ順位',
  poolBalance: 'プール残高',
  holeTied: '引き分け',
  poolGrows: '次ホールプール',
  skinsWinner: '{player}がスキンを獲得！',
  holeSettlement: 'ホール精算',
  netScore: 'ネット',
  rank: '{n}位',
  winner: '勝者',
  resume: 'ゲーム再開',
  finishRound: '確認して終了',
  kaki: 'ゴルフ仲間',
  kakiDeleteConfirm: 'このゴルフ仲間を削除しますか?',
  confirmHoleScore: 'ホール{hole}のスコアを確認',
  holeScoresSummary: 'プレーヤースコア:',
  cancel: 'キャンセル',
  yes: 'はい',
  confirm: '確認',
  switchLang: '言語',
  noStake: '賭け金を入力してください',
  atLeast2: '2人以上のプレーヤーを入力してください',
  gameOver: 'ゲーム終了！',
  backToHome: 'ホームに戻る',
  out: 'アウト',
  in: 'イン',
  total: '合計',
  totalScore: '合計スコア',
  standardPar: 'パー',
  finalSettlement: '最終精算',
  noScoreData: 'まだスコアがありません',
  f9: '前半9H',
  b9: '後半9H',
  f18: '前半18H',
  b18: '後半18H',
  f9Desc: 'ホール1-9',
  b9Desc: 'ホール10-18',
  f18Desc: 'スタンダード1-18',
  b18Desc: '10-18, 1-9',
  duplicateNames: 'プレーヤー名は重複できません',
  screenshotHint: 'スクリーンショットで記録を保存することをお勧めします',
  totalLoss: '合計',
  totalPar: 'PAR',
  noCourses: 'コースが見つかりません',
  trySearch: '別のキーワードをお試しください',
  front9: '前半',
  back9: '後半',
  eagle: 'イーグル',
  birdie: 'バーディー',
  parLabel: 'パー',
  bogey: 'ボギー',
  doubleplus: 'ダブル+',
  selectHoleToEdit: '編集するホールを選択',
  holeJumpTitle: 'ホールへジャンプ',
  holeJumpReturnToast: '残り{n}ホール — ホール{hole}に戻ります',
  editHole: '編集',
  save: '保存',
  scoreUpdated: 'スコア更新済み、金額再計算済み',
  matchPlayDesc: '最低ネットが勝ち、敗者が賭け金を支払う',
  win123Desc: '順位でペナルティ、UPでリスク/リワード',
  skinsDesc: '全員参加、単独最低スコアが総取り',
  baccaratDesc: '1対1対戦、UPで賭け金倍増',
  reportTitle: 'のレポート',
  scoreDistribution: 'スコア分布',
  puttingAnalysis: 'パット分析',
  totalPutts: '合計パット',
  avgPerHole: '平均/ホール',
  onePutt: 'ワンパット',
  threePutts: '3パット以上',
  holes: 'ホール',
  penaltyStats: 'ペナルティ統計',
  waterHazard: 'ウォーター',
  stats: '統計',
  attempts: '回',
  times: '',
  holeByHole: 'ホール別',
  viewFullDetail: '詳細を見る',
  fullDetail: '全詳細',
  strokes: '打',
  putt: 'パット',
  water: 'ウォーター',
  clickNameToView: '名前をタップして詳細表示',
  confirmPutts: 'パット数を確認',
  zeroPuttsWarning: '以下のプレーヤーのパット数が0です:',
  puttsScore: 'スコア',
  puttsStrokes: '',
  puttsPutts: 'パット',
  puttsTip: 'ヒント: チップインでない限り、パット数は通常0ではありません',
  puttsGoBack: '戻る',
  puttsConfirm: '確認',
  mpMultiplayer: 'マルチプレーヤー',
  mpSync: 'マルチプレーヤー同期',
  mpCodePlaceholder: 'コード',
  mpEnter6Digit: '4桁のコードを入力',
  mpJoin: '参加',
  mpPointQr: 'QRコードに向けてください',
  mpQrLoadFail: 'QRライブラリの読み込みに失敗',
  mpLinkCopied: 'リンクをコピーしました！',
  mpCopyLink: 'リンクをコピー',
  mpShareLink: '共有',
  startSolo: 'ソロで開始',
  mpJumbo: 'ジャンボ',
  mpCreateRoom: 'ルーム作成',
  mpWaitingPartner: 'パートナーを待っています',
  mpWaitingStart: '開始待ち',
  mpRoomCode: 'ルームコード',
  mpCopied: 'コピー済み！',
  mpCopyCode: 'コードをコピー',
  mpScanToJoin: 'スキャンして参加',
  mpGameInfo: 'ゲーム情報',
  mpCourse: 'コース',
  mpMode: 'モード',
  mpStake: '賭け金',
  mpRoom: 'ルーム',
  mpPlayerAssignment: 'プレーヤー割り当て',
  mpMine: '自分',
  mpPartner: '相手',
  mpUnclaimed: '未割り当て',
  mpConnected: '接続済み',
  mpError: 'エラー',
  mpConnecting: '接続中...',
  mpStartGame: 'ゲーム開始',
  mpWaitingCreator: '作成者の開始を待っています...',
  mpClaimTitle: 'プレーヤーを選択',
  mpClaimDesc: 'スコアを入力するプレーヤーを選択',
  mpSelectOne: '少なくとも1人選択してください',
  mpConfirmClaim: '選択を確認',
  mpConfirmSubmit: '確認',
  mpWaiting: '待機中...',
  mpConfirmFinish: '確認して終了',
  mpConfirmNext: '確認して次へ',
  mpAdvancedStats: '詳細統計モード',
  mpHolesLabel: 'ホール',
  hcpLabel: 'HCP',
  hideInfo: '閉じる',
  learnMore: '詳しく見る',
  close: '閉じる',
  clearRecent: 'クリア',
  recentCourses: '最近のコース',
  endGame: '終了',
  shareRoundReport: 'ラウンドレポートを共有',
  allDataCleared: 'すべてのゲームデータが削除されます',
  endGameConfirm: 'ゲームを終了しますか？\n未完了のホールはカウントされません',
  holeLabel: 'ホール{n}',
  holeLabelShort: 'H{n}',
  cameraAccessDenied: 'カメラにアクセスできません',
  generateLinkFailed: 'リンクの生成に失敗しました',
  copyFailed: 'コピーに失敗しました',
  retracted: '取り消しました。スコアを編集できます。',
  matchPlayBubble: '各ホール最低ネットが勝ち。引き分けは支払いなし。',
  win123Bubble: 'ネットスコアで順位付け。順位が低いほどペナルティ大。UPでリスク/リワード。',
  skinsBubble: '単独最低スコアのみがポットを獲得。引き分けは次ホールに持ち越し。',
  baccaratBubble: '4人6組の対戦。UPで賭け金を上げる。',
  mpSyncBubble: '自分のプレーヤーは自分で、相手のは相手がスコア入力。自動同期。',
  hcpBubble: 'ハンディキャップ(0-36)：異なるレベルのプレーヤーが公平に競えます。コース難度に応じてストロークが自動配分されます。',
  undoEdit: '取り消して編集',
  waitingProceed: '{badge}の進行を待っています...',
  voiceWithHcp: '{player}、{on}オン{putt}パット、ハンディ{handicap}。',
  voiceNoHcp: '{player}、{on}オン{putt}パット。',
  voiceHoleIntro: 'ホール{hole}、パー{par}、インデックス{index}。',
  voiceHoleIntroNoIdx: 'ホール{hole}、パー{par}。',
  voiceHcpOnHole: '{player}、ハンディ{strokes}ストローク',
  ttsLang: 'ja-JP',
  editLogTitle: '編集履歴',
  editLogHoleTitle: 'ホール{n} 編集履歴',
  editLogEmpty: '編集履歴はありません',
  editLogCount: '{n}件の編集',
  editLogAllRecorded: 'すべての編集が記録されています',
  editLogScore: 'スコア',
  editLogPutts: 'パット',
  editLogUp: 'UP',
  editNotifyTitle: 'ホール{n}のスコアが編集されました',
  editNotifyBy: '{who}が編集',
  editNotifyDetail: 'タップして詳細を見る',
  editLogTapHint: 'ホール番号をタップして編集履歴を表示',
  editLogClose: '閉じる',
  // Viewer Mode 観戦モード
  mpRoleTitle: 'ルームに参加',
  mpRoleDesc: '参加方法を選択',
  mpPlayerRole: 'プレイヤー',
  mpPlayerRoleDesc: '選手を選んでスコア入力',
  mpPlayerTagInput: 'スコア入力',
  mpPlayerTagClaim: '選手選択',
  mpViewerRole: '観戦',
  mpViewerRoleDesc: 'ライブ観戦（読取専用）',
  mpViewerTagLive: 'ライブスコア',
  mpViewerTagNoInput: '入力不可',
  mpViewerBanner: '観戦のみ — スコア入力無効',
  mpViewerReminder: 'この試合を観戦中',
  mpViewerReminderDesc: 'スコアはリアルタイム更新。入力・修正はできません。',
  exit: '退出',
  // Scorecard Section
  scorecardHorizontal: '横表示',
  scorecardVertical: '縦表示',
  shareBtn: '共有',
  penalties: 'ペナルティ',
  // Feedback フィードバック
  feedbackBtn: 'フィードバック',
  feedbackTitle: 'フィードバック',
  feedbackSubtitle: 'HandinCapの改善にご協力ください',
  feedbackRateLabel: '体験を評価',
  feedbackCatLabel: '改善してほしい点は？（複数選択可）',
  feedbackCatNewModes: '新しいゲームモード',
  feedbackCatUI: 'UI・レイアウト',
  feedbackCatSpeed: 'パフォーマンス',
  feedbackCatCourse: 'コースデータ',
  feedbackCatScoring: 'スコアリング',
  feedbackCatMultiplayer: 'マルチプレーヤー',
  feedbackCatBug: 'バグ報告',
  feedbackCatOther: 'その他',
  feedbackCommentPlaceholder: 'ご意見をお聞かせください...\n例：Nassauモードが欲しい',
  feedbackSubmit: '送信',
  feedbackSubmitting: '送信中...',
  feedbackThanks: 'ありがとうございます！',
  feedbackThanksDetail: 'すべてのフィードバックを確認します',
  feedbackSkip: 'また今度',
  feedbackStar1: '悪い',
  feedbackStar2: '普通',
  feedbackStar3: '良い',
  feedbackStar4: 'とても良い',
  feedbackStar5: '最高！',
  // Share page
  shareInvalidLink: '無効なリンク',
  shareInvalidDesc: 'この共有リンクは無効または期限切れです。',
  shareGoTo: 'HandinCapへ',
  poweredBy: 'Powered by',
  onLabel: 'オン',
  avg: '平均',
  totalLabel: '合計',
  // Multiplayer extras
  mpConnectionStatus: '接続状況',
  mpPlayersJoined: '参加プレーヤー',
  mpViewersJoined: '参加観戦者',
  mpNoPlayersYet: 'まだプレーヤーが参加していません。開始可能です — 全プレーヤーのスコアを入力できます。',
  mpProcessing: '処理中...',
  mpClaimed: '割り当て済み',
  mpNoPlayers: 'プレーヤーなし',
  ob: 'OB',
  allConfirmed: '全員確認済み',
  liveSyncing: 'ライブ同期中',
  justNow: 'たった今',
  minsAgo: '{n}分前',
  hrsAgo: '{n}時間前',
  roomNotFound: 'ルームが見つかりません',
  // Round Report
  rrTitle: 'ラウンドレポート',
  rrGolfCourse: 'ゴルフコース',
  rrTotalScorePar: '合計スコア (パー: {n})',
  rrShareImage: '画像を共有',
  rrShareLink: 'リンクを共有',
  rrImageDownloaded: '画像をダウンロードしました',
  rrImageFailed: '画像の生成に失敗しました',
  rrScreenshotFailed: 'スクリーンショットに失敗しました。手動で撮影してください',
  rrOpenApp: 'HandinCapを開く',
  loading: '読み込み中...',
};

export default ja;
